import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import MyTypography from "@saleor/components/MyTypography";
import Skeleton from "@saleor/components/Skeleton";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

interface HeaderInformationProps {
  dataInfo: {
    piNo: string;
    soldToCode: string;
    soldToName: string;
  };
}

const useStyles = makeStyles(
  () => ({
    infoCard: {
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      borderRadius: 6,
      padding: "1rem 2.4rem"
    },
    infoText: {
      color: "#FFFFFF"
    },
    infoNumber: {
      color: "#FFFFFF"
    }
  }),
  {
    name: "HeaderInformation"
  }
);

const HeaderInformation: React.FC<HeaderInformationProps> = props => {
  const { dataInfo } = props;
  const classes = useStyles();
  const intl = useIntl();

  return (
    <>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Paper className={classes.infoCard}>
            <MyTypography variant="subtitle3" className={classes.infoText}>
              {intl.formatMessage({ defaultMessage: "PI No." })}
            </MyTypography>
            <MyTypography variant="h7" className={classes.infoNumber}>
              {dataInfo?.piNo ? dataInfo.piNo : <Skeleton />}
            </MyTypography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={6}>
          <Paper className={classes.infoCard}>
            <MyTypography variant="subtitle3" className={classes.infoText}>
              {intl.formatMessage({ defaultMessage: "Sold to" })}
            </MyTypography>
            <MyTypography variant="h7" className={classes.infoNumber}>
              {dataInfo?.soldToCode && dataInfo?.soldToName ? (
                `${dataInfo.soldToCode} - ${dataInfo.soldToName}`
              ) : (
                <Skeleton />
              )}
            </MyTypography>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default HeaderInformation;
